import TableModalButton from 'components/common/TableModal/TableModalButton'
import { pricesListsMassiveUpdateListFormFields } from 'constants/voucherConfig/PricesListsMassiveUpdateConfig/PricesListsMassiveUpdateListFormFields'
import { renderInput } from 'lib/FormUtils'
import { ICrudGenericFields } from 'models/CrudInterface'
import {
	IPricesListsMassiveUpdateListFormFieldsProps,
	IPricesListsMassiveUpdateListFormFieldsState
} from 'models/PricesListsMassiveUpdate'
import {
	IGetTableGenericRes,
	IGetTableGenericResArray
} from 'models/TableCalls/TableCallsInterface'
import React, { Component, Fragment } from 'react'
import _ from 'underscore'

class PricesListsMassiveUpdateListFormFields extends Component<
	IPricesListsMassiveUpdateListFormFieldsProps,
	IPricesListsMassiveUpdateListFormFieldsState
> {
	constructor(props: IPricesListsMassiveUpdateListFormFieldsProps) {
		super(props)
		this.state = {
			idField: '',
			fieldConfig: {
				id: '',
				type: '',
				width: '',
				autoComplete: '',
				comboData: '',
				maxChars: 0,
				dependsOn: {
					id: '',
					values: [
						{
							idValue: '',
							disabled: false
						}
					]
				}
			},
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		}
	}

	componentDidMount = () => {
		const { field } = this.props
		const idField = field.idCampo.trim()

		const addData = _.find(
			pricesListsMassiveUpdateListFormFields,
			(field: ICrudGenericFields) => {
				return field.id === idField
			}
		)
		addData && this.setState({ dependsOn: addData.dependsOn })
		addData && this.setState({ fieldConfig: addData })
		addData && this.setState({ idField: idField })
		addData && this.setState({ defaultValue: addData.default })
	}

	componentDidUpdate = (
		prevProps: IPricesListsMassiveUpdateListFormFieldsProps
	) => {
		const {
			formikProps,
			handleClientsPricesLists,
			handleSelectListValueChange,
			pricesLists
		} = this.props
		const { formikProps: prevFormikProps } = prevProps
		const { idField, defaultValue, fieldConfig } = this.state

		if (
			fieldConfig.type !== 'combo' &&
			!formikProps.values[idField] &&
			formikProps.values[idField] !== 0 &&
			defaultValue
		) {
			formikProps.setFieldValue(idField, defaultValue)
		}

		if (
			idField === 'lista_cliente' &&
			pricesLists &&
			prevProps.pricesLists !== pricesLists
		) {
			formikProps.setFieldValue(idField, pricesLists.Descrip)
		}

		if (
			idField === 'lk_clie' &&
			formikProps.values[idField] &&
			prevFormikProps.values[idField] !== formikProps.values[idField]
		) {
			handleClientsPricesLists(formikProps.values.lk_clie_id)
		}
		if (
			idField === 'lk_sel_list' &&
			formikProps.values[idField] &&
			prevFormikProps.values[idField] !== formikProps.values[idField]
		) {
			handleSelectListValueChange(formikProps.values[idField])
		}
	}

	handleBlur = async () => {
		const { formikProps, handleIsSearchingProducts, handleIsSearchingClients } =
			this.props
		const { idField } = this.state
		formikProps.setTouched({
			...formikProps.touched,
			[idField]: true
		})
		idField === 'lk_clie' && handleIsSearchingClients(false)
		idField === 'lk_prod_lp' && handleIsSearchingProducts(false)
	}

	comboDataField = (data: IGetTableGenericResArray) => {
		const values: { cod_valor: string; desc_valor: string }[] = []
		data &&
			_.each(data.lista, (opt: IGetTableGenericRes) => {
				values.push({ cod_valor: opt.codigo, desc_valor: opt.descrip })
			})
		return values
	}

	renderInputs = (
		field: any,
		formikProps: any,
		disableForm: boolean,
		fieldConfig: ICrudGenericFields
	) => {
		const {
			crudProps,
			handleIsSearchingProducts,
			handleIsSearchingClients,
			handleSearchClients,
			handleSearchProducts,
			listProducts,
			listClients,
			isSearchingClients,
			isSearchingProducts
		} = this.props

		const { values, setFieldValue } = formikProps
		const { dependsOn, idField } = this.state
		const addData = fieldConfig

		const clients = listClients
			? listClients.clientes.map((opt: any) => {
					return { id: opt.idCliente, label: opt.Rsocial }
			  })
			: []

		const products =
			listProducts && listProducts.clientes
				? listProducts.clientes.map((opt: any) => ({
						id: opt.niprod,
						label: opt.descrip
				  }))
				: []

		addData &&
			(field = {
				...field,
				tipo: addData.type,
				colInput: addData.width,
				colLabel: addData.labelWidth,
				autoComplete: addData.autoComplete,
				disabled: addData && addData.disabled,
				onBlur: this.handleBlur,
				customProps: {
					maxLength: addData.maxChars
				}
			})

		if (field.tipo === 'combo') {
			addData &&
				(field.valores = crudProps[addData.comboData as keyof typeof crudProps]
					? this.comboDataField(
							crudProps[addData.comboData as keyof typeof crudProps]
					  )
					: [])
			!formikProps.values[idField] &&
				(field.onChange = (event: any) =>
					setFieldValue(field.idCampo, event.target.value))
		} else if (field.tipo === 'check') {
			field.customProps = {
				checked: Number(values[field.idCampo])
			}
		}
		if (field.idCampo === 'lk_clie') {
			field.customProps = {
				minLength: 3,
				handleSearch: handleSearchClients,
				handleLoading: isSearchingClients,
				auoptions: clients,

				handleSelect: (client: { id: string; label: string }) => {
					formikProps.setFieldValue('lk_clie', client.label)
					formikProps.setFieldValue('lk_clie_id', client.id)
					handleIsSearchingClients(false)
				},
				disable: disableForm
			}
		}
		if (field.idCampo === 'lk_prod_lp') {
			field.customProps = {
				minLength: 3,
				handleSearch: handleSearchProducts,
				handleLoading: isSearchingProducts,
				auoptions: products,

				handleSelect: (product: { id: string; label: string }) => {
					formikProps.setFieldValue('lk_prod_lp', product.label)
					formikProps.setFieldValue('lk_prod_lp_id', product.id)
					handleIsSearchingProducts(false)
				},
				disable: disableForm
			}
		}

		if (field.idCampo === 'lk_list') {
			field.suffix = !disableForm ? (
				<TableModalButton
					modalTitle={'modalTitle'}
					idOperacion={crudProps.idOperacion}
					listCode={'SF12'}
					handleConfirmResult={(params: string) => {
						formikProps.setFieldValue('lk_list', params)
					}}
				/>
			) : (
				<></>
			)
		}

		dependsOn.id !== '' &&
			_.each(dependsOn.values, (dependency) => {
				values[dependsOn.id] === dependency.idValue &&
					(field.disabled = dependency.disabled)
			})

		if (!field.editable) field.disabled = true

		if (field.visible) {
			return renderInput(field, formikProps, disableForm)
		}
	}

	render() {
		const { field, formikProps, crudProps } = this.props
		const { fieldConfig } = this.state

		return (
			<Fragment>
				{this.renderInputs(
					field,
					formikProps,
					crudProps.disableForm,
					fieldConfig
				)}
			</Fragment>
		)
	}
}

export default PricesListsMassiveUpdateListFormFields
